import React, { Component } from 'react';
import { Pagination, Row, Col, Container, Modal } from 'react-bootstrap';
import { SubmitBtn } from '../../theme/MorsTheme';
import { ContentDiv, BodyHeaderDiv, BodyHeaderText } from '../../theme/MorsTheme';
import { pager } from '../../Utilities/PaginateUtil';
import { getTaxReports } from '../../Utilities/WSUtil';
import Loader from '../../components/ui/Loader';

class TaxReportFileList extends Component {

    constructor(props) {
        super(props);
        this.viewPdf = this.viewPdf.bind(this);

        this.state = {
            pager: {},
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 20,
            items: [],
            pageOfItems: [],
            confirm: false,
            agree: false,
            valid: false,
            selectAll: true,
            loading: false
        };
    }

    goBack = e => {
        e.preventDefault();

        this.props.history.goBack();
    }
    first() {
        const res = pager(this.state.items, 1, this.state.itemsPerPage);
        this.setState({ currentPage: 1, pageOfItems: res.items, totalPages: res.totalPages })
    }

    previous() {
        const page = this.state.currentPage;
        const prevPage = page - 1;
        if (prevPage > 0) {

            const res = pager(this.state.items, prevPage, this.state.itemsPerPage);
            this.setState({ currentPage: prevPage, pageOfItems: res.items, totalPages: res.totalPages })
        }
    }

    next() {

        const page = this.state.currentPage;
        const nextPage = page + 1;

        if (nextPage <= this.state.totalPages) {
            const res = pager(this.state.items, nextPage, this.state.itemsPerPage);
            this.setState({ currentPage: nextPage, pageOfItems: res.items, totalPages: res.totalPages })
        }
    }

    last() {
        const items = this.state.items;
        if (items && items.length > 0) {
            const res = pager(items, this.state.totalPages, this.state.itemsPerPage);
            this.setState({ currentPage: res.totalPages, pageOfItems: res.items, totalPages: res.totalPages })
        }
    }

    componentWillMount() {
        this.loadData();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.items !== prevProps.items) {
            this.setPage(this.props.initialPage);
        }
    }

    loadData() {
        if (this.props.cwtListParam) {
            this.setState({ loading: true })
            getTaxReports(this.props.cwtListParam)
                .then(response => {

                    if (response.cwtList) {
                        response.cwtList.forEach(item => item.selected = true);
                        var res = pager(response.cwtList, 1, this.state.itemsPerPage);
                        this.setState({ pageOfItems: res.items, totalPages: res.totalPages, items: response.cwtList, loading: false })

                    }

                })
                .catch(error => {
                    this.setState({ loading: false })
                });
        }

    }
    renderButton() {
        if (this.state.items.length > 0) {
            return (
                <>

                    <Row style={{ marginTop: '20px', textAlign: 'center' }}>
                        <Col>
                            <SubmitBtn style={{ color: '#FFFFFF' }} onClick={this.goBack}>Back</SubmitBtn>
                        </Col>


                    </Row>
                </>
            )
        } else {
            return (
                <>
                    <Row>
                        <Col>
                            <div style={this.state.items.length === 0 ? { display: 'block' } : { display: 'none' }}>
                                <span style={{ color: 'red' }}>Sorry, there is/are no recorded transaction/s for the date you selected.</span>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '20px', textAlign: 'center' }}>
                        <Col>
                            <SubmitBtn style={{ color: '#FFFFFF' }} onClick={this.goBack}>Back</SubmitBtn>
                        </Col>


                    </Row>
                </>
            )
        }
    }
    viewPdf(item) {
        this.props.getPdfFile(item);
        this.props.history.push("/viewPdf")
    }
    renderTable() {
        if (this.state.loading) {
            return (<></>);
        } else {
            return (
                <Container fluid={true}>
                    <Row as={Row}  md={12} xs={12} style={this.state.pageOfItems.length !== 0 ? { display: 'block' } : { display: 'none' }}>
                        <Row >
                            <Col xs={4} md={4}>Date</Col>
                            <Col xs={2} md={2}>MID</Col>
                            <Col xs={5} md={5}>Filename</Col>
                        </Row>
                        {
                            this.state.pageOfItems.map((item, index) =>
                                <Row style={{ wordBreak: 'break-all', fontSize: '12px' }} key={index} md={12} xs={12}>
                                    <Col xs={4} md={4}><span style={{ fontSize: '12px' }}>{item.date}</span></Col>
                                    <Col xs={2} md={2}><span style={{ fontSize: '12px' }}>{item.merchant}</span></Col>
                                    <Col xs={5} md={5}>
                                        <span style={{ fontSize: '12px' }} className="clickable" onClick={() => this.viewPdf(item)}>
                                            {item.filename}
                                            {/* <Link to={{ pathname: "/viewPdf", search: `?merchant=${item.merchant}&schedule=${item.taxSched}&period=${item.period}&filename=${item.filename}` }}>
                                                {item.filename}
                                            </Link> */}
                                        </span>
                                    </Col>
                                </Row>
                            )
                        }

                    </Row>
                    <div align="center" style={this.state.pageOfItems.length !== 0 ? { display: 'block', marginTop: '20px' } : { display: 'none' }}>
                        <Pagination style={{ display: 'flex', justifyContent: 'center' }}>
                            <Pagination.First onClick={() => this.first()} />
                            <Pagination.Prev onClick={() => this.previous()} />
                            <Pagination.Next onClick={() => this.next()} />
                            <Pagination.Last onClick={() => this.last()} />
                        </Pagination>

                        <div align="center">
                            <span>Page {this.state.currentPage}</span> / {" "}
                            <span>{this.state.totalPages}</span>
                        </div>
                    </div>
                    {this.renderButton()}

                </Container>
            );
        }
    }
    render() {

        return (
            <div>
                <BodyHeaderDiv>
                    <BodyHeaderText>List of CWT/BIR 2307</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv>
                    {this.renderTable()}
                </ContentDiv>
                <Modal show={this.state.loading} backdrop={'static'} centered={true} backdropClassName='fade' dialogClassName="modal-bdox">
                    <div>

                        <Loader text="Loading ..."></Loader>
                    </div>
                </Modal>
            </div>
        )

    }

}

export default TaxReportFileList;
